import { echartsContent, mathFormat } from '@/pages/opinion/utils';

import echartsFormatter from './formatter';
import { formatTimeXAxisText } from '@/pages/opinion/utils/chart';
import { legendFormat, richImgMap } from './commonOption';
import { getAxisPointer } from '@/pages/opinion/components/EChartCommon';

export default function (
  showType: string,
  formatMessage: any,
  data: any,
  filter: any,
  showTotal: boolean,
) {
  return {
    tooltip: {
      trigger: 'axis',
      backgroundColor: 'rgba(255, 255, 255, 0.75)',
      borderWidth: 0,
      borderRadius: 6,
      textStyle: {
        color: '#FFFFFF',
        fontSize: 12,
      },
      confine: true,
      hideDelay: 200,
      triggerOn: 'mousemove',
      padding: 0,
      formatter: (params: any) =>
        echartsFormatter(params, 'mdauOption', data, filter, formatMessage),
    },
    grid: {
      right: '0%',
      bottom: '36px', // 要和 legend 联动计算这个高度
      top: '20px',
      containLabel: true,
    },
    axisPointer: getAxisPointer((data) => {
      return formatTimeXAxisText(data.value, filter?.date_type || 'daily');
    }),
    color: ['#5086F3', '#F8CC6A'],
    legend: {
      data: [
        formatMessage({ id: 'Positive' }),
        formatMessage({ id: 'Neutral' }),
        formatMessage({ id: 'Negative' }),
        formatMessage({ id: `Sensor Tower ${showType}` }),
        formatMessage({ id: `Predicted ${showType}` }),
      ],
      formatter: (value: any) => legendFormat(value, formatMessage),
      textStyle: {
        color: '#888888',
        fontWeight: 400,
        fontSize: '12px',
        rich: {
          a: {
            color: '#888888',
            fontSize: 12,
            fontWeight: 400,
          },
          ...richImgMap,
        },
      },
    },
    xAxis: [
      {
        axisLabel: {
          formatter: (value: any) =>
            formatTimeXAxisText(value, filter?.date_type || 'daily'),
        },
        data: [],
      },
    ],
    yAxis: [
      {
        type: 'value',
        axisLabel: {
          formatter: (value: any) => echartsContent(value),
        },
        splitNumber: 5,
      },
      {
        type: 'value',
        axisLabel: {
          formatter: (value: any) => echartsContent(value),
        },
        splitNumber: 5,
      },
    ],
    series: [
      {
        name: 'total总数',
        type: 'bar',
        barMaxWidth: '70px', // 柱子宽度同实体柱子，否则会错位
        barGap: '-100%', // 左移100%，stack不再与需堆叠的柱子在一列
        label: {
          normal: {
            show: showTotal,
            position: 'top', // 位置设为top
            formatter: (c: any) => mathFormat(c?.value),
            textStyle: { color: '#444' },
          },
        },
        itemStyle: {
          normal: {
            color: 'rgba(128, 128, 128, 0)', // 为透明
          },
        },
        data: [],
      },
      {
        name: formatMessage({ id: 'Positive' }),
        type: 'bar',
        stack: '1',
        yAxisIndex: 0,
        data: [],
        itemStyle: {
          color: '#69D19C',
        },
        barMaxWidth: '70px',
      },
      {
        name: formatMessage({ id: 'Neutral' }),
        type: 'bar',
        stack: '1',
        yAxisIndex: 0,
        data: [],
        itemStyle: {
          color: '#6E7794',
        },
        barMaxWidth: '70px',
      },
      {
        name: formatMessage({ id: 'Negative' }),

        type: 'bar',
        stack: '1',
        yAxisIndex: 0,
        data: [],
        itemStyle: {
          color: '#F17C86',
        },
        barMaxWidth: '70px',
      },
      {
        name: `Sensor Tower ${showType}`,
        type: 'line',
        yAxisIndex: 1,
        lineStyle: {
          color: '#5086F3',
        },
        data: [],
      },
      {
        name: `Predicted ${showType}`,
        type: 'line',
        yAxisIndex: 1,
        lineStyle: {
          color: '#F8CC6A',
        },
        data: [],
      },
      {
        name: showType,
        type: 'line',
        yAxisIndex: 1,
        lineStyle: {
          color: '#5086F3',
        },
        data: [],
      },
    ],
  };
}
